import { UNDO, REDO, HISTORY_ACTION } from '../actionTypes'
import firebase from 'firebase/app'

const initialState = {
  past: [],
  future: []
}

export const undo = () => (dispatch, getState) => {
  const state = getState().history
  if (!state.past.length) return
  const { backward, action } = state.past[0]
  dispatch({ type: UNDO, payload: { action } })

  return firebase
    .database()
    .ref()
    .update(backward)
}

export const redo = () => (dispatch, getState) => {
  const state = getState().history
  if (!state.future.length) return
  const { forward, action } = state.future[0]
  dispatch({ type: REDO, payload: { action } })

  return firebase
    .database()
    .ref()
    .update(forward)
}

export const historyReducer = (state = initialState, action) => {
  if (action.nonHistory) return state
  let newState = { ...state }
  switch (action.type) {
    case UNDO:
      newState.future.unshift(newState.past.shift())
      return newState
    case REDO:
      newState.past.unshift(newState.future.shift())
      return newState
    case HISTORY_ACTION:
      newState.past.unshift(action.payload)
      newState.future = []
      return newState
    default:
      return newState
  }
}
